// This file is automatically generated. Do not edit manually.

import { SafetyControlSurvey } from "src/api/generated/erp/db/types/tables/safetyControlSurvey";
import { SafetyControlSurveyTeam } from "src/api/generated/erp/db/types/tables/safetyControlSurveyTeam";
import { SafetyControlSurveyType } from "src/api/generated/erp/db/types/enums/safetyControlSurveyType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SafetyControlSurveyEditApi {
	export async function getSurveyFormInitData(): Promise<SafetyControlSurveyEditApi_SurveyFormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/edit/getSurveyFormInitData",
			method: "POST",
			data: {},
		});
		return response as SafetyControlSurveyEditApi_SurveyFormInitData;
	}

	export async function insert(args: { survey: SafetyControlSurvey }): Promise<SafetyControlSurvey> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/edit/insert",
			method: "POST",
			data: {
				survey: args.survey,
			},
		});
		return response as SafetyControlSurvey;
	}

	export async function update(args: { survey: SafetyControlSurvey }): Promise<SafetyControlSurvey> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/edit/update",
			method: "POST",
			data: {
				survey: args.survey,
			},
		});
		return response as SafetyControlSurvey;
	}

	export async function delete_(args: { safetyControlSurveyId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/edit/delete",
			method: "POST",
			data: {
				safetyControlSurveyId: args.safetyControlSurveyId,
			},
		});
		return response as void;
	}
}

export interface SafetyControlSurveyEditApi_SurveyFormInitData {
	surveyTypeOptions: Array<SafetyControlSurveyEditApi_SurveyTypeOption>;
	teamOptions: Array<SafetyControlSurveyTeam>;
}

export interface SafetyControlSurveyEditApi_SurveyTypeOption {
	label: string;
	value: SafetyControlSurveyType;
}
